import { render, staticRenderFns } from "./linear-scale.vue?vue&type=template&id=67964296&"
import script from "./linear-scale.vue?vue&type=script&lang=ts&"
export * from "./linear-scale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports